import RoomContextProviders from '@contexts/RoomContextProviders';
import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import { AudioSession, LiveKitRoom } from '@livekit/react-native';
import { useGetRoom, useLeaveRoom } from '@queries/rooms';
import { LIVEKIT_URL } from '@sunrise-ui/api-client';
import { withAuthGate } from '@sunrise-ui/composites';
import { Loader, useAuthStore } from '@sunrise-ui/primitives';
import RoomView from '@templates/RoomView';
import { useKeepAwake } from 'expo-keep-awake';
import React, { useEffect } from 'react';

function EventScreen() {
  const { roomToken, currentRoomId } = useCurrentEventInfo();
  const { currentUserId } = useAuthStore();
  const { data: room, isLoading } = useGetRoom(currentRoomId);
  const { mutate: leaveRoom } = useLeaveRoom();
  useKeepAwake();

  const isHost = room?.user_id === currentUserId;
  // Start the audio session first.
  useEffect(() => {
    if (isHost) {
      const start = async () => {
        await AudioSession.startAudioSession();
      };

      void start();
      return () => {
        void AudioSession.stopAudioSession();
      };
    }
  }, [isHost]);

  if (isLoading) return <Loader />;

  return (
    <LiveKitRoom
      serverUrl={LIVEKIT_URL}
      token={roomToken}
      connect={true}
      options={{
        // Use screen pixel density to handle screens with differing densities.
        adaptiveStream: { pixelDensity: 'screen' },
      }}
      audio={isHost}
      video={isHost}
      onDisconnected={leaveRoom}
    >
      <RoomContextProviders>
        <RoomView />
      </RoomContextProviders>
    </LiveKitRoom>
  );
}

export default withAuthGate(EventScreen);
